export default __webpack_public_path__ + "static/media/AboutContent.85def7d4.md";